import { render, staticRenderFns } from "./CvElement.vue?vue&type=template&id=330371fc&scoped=true"
import script from "./CvElement.vue?vue&type=script&lang=js"
export * from "./CvElement.vue?vue&type=script&lang=js"
import style0 from "./CvElement.vue?vue&type=style&index=0&id=330371fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330371fc",
  null
  
)

export default component.exports